import { cn } from "@/lib/utils";

interface LogoProps {
  variant?: "light" | "dark";
  showTagline?: boolean;
  className?: string;
}

export function Logo({ variant = "light", showTagline = false, className }: LogoProps) {
  const wordmark = variant === "light" ? "text-cream-50" : "text-navy-800";
  const tagline = variant === "light" ? "text-bronze-400" : "text-bronze-600";

  return (
    <span className={cn("inline-flex flex-col leading-none", className)}>
      <span
        className={cn("font-script text-3xl md:text-[2.25rem]", wordmark)}
        style={{ fontFamily: "var(--font-script)" }}
      >
        Currency Thoughts
      </span>
      {showTagline && (
        <span
          className={cn(
            "mt-1 font-sans text-[10px] font-semibold uppercase tracking-[0.22em]",
            tagline,
          )}
        >
          Building Generational Wealth
        </span>
      )}
    </span>
  );
}

export default Logo;